import { render, staticRenderFns } from "./QuickItemView.vue?vue&type=template&id=cf5e1868"
import script from "./QuickItemView.vue?vue&type=script&lang=js"
export * from "./QuickItemView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf5e1868')) {
      api.createRecord('cf5e1868', component.options)
    } else {
      api.reload('cf5e1868', component.options)
    }
    module.hot.accept("./QuickItemView.vue?vue&type=template&id=cf5e1868", function () {
      api.rerender('cf5e1868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quickitem/QuickItemView.vue"
export default component.exports